import React from "react";

type Theme = "blue" | "emerald" | "amber" | "red";

interface MetricCardProps {
  icon: string;
  title: string;
  value: number;
  label: string;
  theme?: Theme;
  testId: string;
  onClick: () => void;
}

const themeConfig: Record<
  Theme,
  { glow: string; card: string; label: string }
> = {
  blue: {
    glow: "bg-gradient-to-r from-blue-600 to-indigo-600",
    card: "bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-700 border-blue-400/30 shadow-blue-500/25",
    label: "text-blue-100",
  },
  emerald: {
    glow: "bg-gradient-to-r from-emerald-600 to-teal-600",
    card: "bg-gradient-to-br from-emerald-500 via-emerald-600 to-teal-700 border-emerald-400/30 shadow-emerald-500/25",
    label: "text-emerald-100",
  },
  amber: {
    glow: "bg-gradient-to-r from-amber-500 to-orange-600",
    card: "bg-gradient-to-br from-amber-500 via-orange-500 to-orange-700 border-amber-400/30 shadow-amber-500/25",
    label: "text-amber-100",
  },
  red: {
    glow: "bg-gradient-to-r from-red-500 to-rose-600",
    card: "bg-gradient-to-br from-red-500 via-red-600 to-rose-700 border-red-400/30 shadow-red-500/25",
    label: "text-red-100",
  },
};

const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  title,
  value,
  label,
  theme = "blue",
  testId,
  onClick,
}) => {
  const t = themeConfig[theme];
  return (
    <div
      className="relative group cursor-pointer"
      onClick={onClick}
      data-testid={testId}
    >
      <div
        className={`absolute inset-0 ${t.glow} rounded-2xl blur opacity-75 group-hover:opacity-100 transition-opacity`}
      />
      <div
        className={`relative ${t.card} rounded-2xl p-5 border shadow-lg`}
      >
        <div className="flex items-start justify-between">
          <div>
            <p
              className="text-4xl font-black text-white drop-shadow-lg"
              data-testid={`${testId}-value`}
            >
              {value}
            </p>
            <p className={`text-sm font-semibold ${t.label} mt-1`}>{title}</p>
            <p className="text-xs text-white/60 mt-0.5">{label}</p>
          </div>
          <div className="w-11 h-11 bg-white/20 rounded-xl flex items-center justify-center backdrop-blur-sm flex-shrink-0">
            <span className="text-xl">{icon}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
